module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-owner-address":"Eigentümeradresse","not-recorded-yet":"Noch nicht erfasst","not-recorded":"nicht erfasst"},"fr":{"not-recorded":"pas saisi","not-recorded-yet":"Pas encore saisi","title-owner-address":"Adresse du propriétaire"},"it":{"not-recorded":"non registrato","not-recorded-yet":"Non ancora registrato","title-owner-address":"Indirizzo del proprietario"}}')
  delete Component.options._Ctor
}
